import * as React from "react"
const SvgAd = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M7.5 13.929v.75a.73.73 0 0 1-.75.75.73.73 0 0 1-.75-.75v-4.25a.97.97 0 0 1 .287-.713A.97.97 0 0 1 7 9.43h3a.97.97 0 0 1 .713.287q.287.288.287.713v4.25a.73.73 0 0 1-.75.75.73.73 0 0 1-.75-.75v-.75zm2-1.5h-2v-1.5h2zm7 3h-2.75a.73.73 0 0 1-.75-.75v-4.5a.73.73 0 0 1 .75-.75h2.75q.6 0 1.05.45t.45 1.05v3q0 .6-.45 1.05t-1.05.45m0-1.5h-2v-3h2z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M4 20.429q-.824 0-1.413-.588A1.93 1.93 0 0 1 2 18.43v-12q0-.825.587-1.413A1.93 1.93 0 0 1 4 4.43h16q.824 0 1.413.587Q22 5.605 22 6.43v12q0 .825-.587 1.412A1.93 1.93 0 0 1 20 20.43H4ZM4 6.432v11.993l.002.002.001.002h15.994l.001-.002.002-.002V6.432l-.002-.002-.001-.001H4.003l-.001.001z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgAd
